import * as React from 'react';
import { Body2, UIHeading2, UIHeading4 } from '@cian/ui-kit';

import { INewbuildingSummaryCell } from '../../../../../../types/newbuildingsCompare';
import { NewbuildingCallButton } from '../../../../../../containers/NewbuildingCallButton';
import { NewbuildingChatButton } from '../../../../../../containers/NewbuildingChatButton';
import { Link } from '../../../../../Link';
import { Photo } from './parts/Photo';
import { Rating } from './parts/Rating';
import * as style from './NewbuildingSummaryCell.css';

export interface INewbuildingSummaryCellProps {
  cell: INewbuildingSummaryCell;
}

export const NewbuildingSummaryCell = ({ cell }: INewbuildingSummaryCellProps): React.JSX.Element => {
  const { data, state } = cell;

  if (!data) {
    return <Body2>{state.text ?? ''}</Body2>;
  }

  const { name, fullUrl, imageUrl, isFavorite, priceRange, reviews, builders, sellers } = data;
  const hasChat = [...builders, ...sellers].some(contact => contact.chat?.enabled);

  return (
    <div className={style['container']}>
      <Photo gaLabel={fullUrl} id={data.id} imageUrl={imageUrl} isFavorite={isFavorite} name={name} />
      <div className={style['info']}>
        <div className={style['price-facts']}>
          <div className={style['name']}>
            <Link href={fullUrl} target="_blank">
              <UIHeading2 color="text-main-default">{name}</UIHeading2>
            </Link>
          </div>
          <div className={style['facts']}>
            {priceRange && <UIHeading4>{priceRange}</UIHeading4>}
            <Rating countText={reviews.countText} rating={reviews.rating} />
          </div>
        </div>
        <div className={style['buttons']}>
          <NewbuildingCallButton builders={builders} newbuildingId={data.id} sellers={sellers} size="M" url={fullUrl} />
          {hasChat && (
            <NewbuildingChatButton
              builders={builders}
              newbuildingId={data.id}
              sellers={sellers}
              size="M"
              url={fullUrl}
            />
          )}
        </div>
      </div>
    </div>
  );
};
